/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * Menu Categories Custom Element
 * Handles tabbed navigation for menu categories in the mobile drawer
 */
var MenuCategories = /*#__PURE__*/function (_HTMLElement) {
  _inherits(MenuCategories, _HTMLElement);
  var _super = _createSuper(MenuCategories);
  function MenuCategories() {
    var _this;
    _classCallCheck(this, MenuCategories);
    _this = _super.call(this);

    // Get all category buttons and content panels
    _this.categoryButtons = _this.querySelectorAll('.menu-category-button');
    _this.categoryContents = _this.querySelectorAll('.menu-category-content');

    // Initialize the component
    _this.init();
    return _this;
  }

  /**
   * Initialize the menu categories functionality
   */
  _createClass(MenuCategories, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      if (this.categoryButtons.length === 0 || this.categoryContents.length === 0) {
        return;
      }

      // Add click event listeners to each category button
      this.categoryButtons.forEach(function (button, index) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.activateCategory(index);
        });

        // Add keyboard support
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            _this2.activateCategory(index);
          }
          // Arrow key navigation
          else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            _this2.navigateWithArrows(event.key, index);
          }
        });
      });

      // Set initial active state (first category should be active)
      this.activateCategory(0);
    }

    /**
     * Activate a specific category tab
     * @param {number} index - Index of the category to activate
     */
  }, {
    key: "activateCategory",
    value: function activateCategory(index) {
      if (index < 0 || index >= this.categoryButtons.length) {
        return;
      }

      // Remove active state from all buttons and contents
      this.categoryButtons.forEach(function (button, i) {
        button.classList.remove('is-active');
        button.setAttribute('aria-selected', 'false');
        button.setAttribute('tabindex', '-1');
      });
      this.categoryContents.forEach(function (content, i) {
        content.classList.remove('is-active');
        content.setAttribute('hidden', '');
      });

      // Add active state to selected button and content
      var activeButton = this.categoryButtons[index];
      var activeContent = this.categoryContents[index];
      if (activeButton && activeContent) {
        activeButton.classList.add('is-active');
        activeButton.setAttribute('aria-selected', 'true');
        activeButton.setAttribute('tabindex', '0');
        activeContent.classList.add('is-active');
        activeContent.removeAttribute('hidden');
      }

      // Store current active index
      this.activeIndex = index;
    }

    /**
     * Handle arrow key navigation
     * @param {string} key - The key that was pressed
     * @param {number} currentIndex - Current active index
     */
  }, {
    key: "navigateWithArrows",
    value: function navigateWithArrows(key, currentIndex) {
      var newIndex;
      if (key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.categoryButtons.length;
      } else if (key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.categoryButtons.length) % this.categoryButtons.length;
      }
      if (newIndex !== undefined) {
        this.activateCategory(newIndex);
        this.categoryButtons[newIndex].focus();
      }
    }

    /**
     * Get the currently active category index
     * @returns {number} Active category index
     */
  }, {
    key: "getActiveIndex",
    value: function getActiveIndex() {
      return this.activeIndex || 0;
    }

    /**
     * Get the currently active category button
     * @returns {HTMLElement|null} Active category button element
     */
  }, {
    key: "getActiveButton",
    value: function getActiveButton() {
      return this.categoryButtons[this.getActiveIndex()] || null;
    }

    /**
     * Get the currently active category content
     * @returns {HTMLElement|null} Active category content element
     */
  }, {
    key: "getActiveContent",
    value: function getActiveContent() {
      return this.categoryContents[this.getActiveIndex()] || null;
    }
  }]);
  return MenuCategories;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
if (!customElements.get('menu-categories')) {
  customElements.define('menu-categories', MenuCategories);
}

/**
 * Free Shipping Message Custom Element
 * Dynamically shows/hides free shipping message based on variant price
 */
var FreeShippingMessage = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(FreeShippingMessage, _HTMLElement2);
  var _super2 = _createSuper(FreeShippingMessage);
  function FreeShippingMessage() {
    var _this3;
    _classCallCheck(this, FreeShippingMessage);
    _this3 = _super2.call(this);

    // Get minimum price threshold from data attribute (in cents)
    _this3.threshold = parseInt(_this3.dataset.threshold) * Shopify.currency.rate;
    _this3.productPrice = parseInt(_this3.dataset.productPrice);
    if (_this3.productPrice != null && _this3.productPrice >= _this3.threshold) {
      _this3.classList.add('qualified');
      _this3.setAttribute('aria-hidden', 'false');
    }

    // Listen for variant change events
    document.addEventListener('productVariantChanged', _this3.handleVariantChange.bind(_assertThisInitialized(_this3)));
    return _this3;
  }

  /**
   * Handle variant change events
   * @param {CustomEvent} event - The variant changed event
   */
  _createClass(FreeShippingMessage, [{
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var _event$detail = event.detail,
        variant = _event$detail.variant,
        available = _event$detail.available;
      if (!variant) {
        this.classList.remove('qualified');
        return;
      }

      // Get variant price (in cents)
      var variantPrice = variant.price;

      // Update visibility based on price
      this.updateVisibility(variantPrice);
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility(currentPrice) {
      // Check if price qualifies for free shipping
      if (currentPrice >= this.minimumPrice) {
        this.classList.add('qualified');
      } else {
        this.classList.remove('qualified');
      }
    }
  }]);
  return FreeShippingMessage;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the free shipping message custom element
if (!customElements.get('free-shipping-message')) {
  customElements.define('free-shipping-message', FreeShippingMessage);
}
var FreeShippingBadge = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(FreeShippingBadge, _HTMLElement3);
  var _super3 = _createSuper(FreeShippingBadge);
  function FreeShippingBadge() {
    var _this4;
    _classCallCheck(this, FreeShippingBadge);
    _this4 = _super3.call(this);
    _this4.threshold = parseInt(_this4.dataset.threshold) * Shopify.currency.rate;
    _this4.productPrice = parseInt(_this4.dataset.productPrice);
    if (_this4.productPrice != null && _this4.productPrice >= _this4.threshold) {
      _this4.style.display = 'block';
      _this4.setAttribute('aria-hidden', 'false');
    }
    return _this4;
  }
  return _createClass(FreeShippingBadge);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('free-shipping-badge')) {
  customElements.define('free-shipping-badge', FreeShippingBadge);
}
var FreeGiftsBanner = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(FreeGiftsBanner, _HTMLElement4);
  var _super4 = _createSuper(FreeGiftsBanner);
  function FreeGiftsBanner() {
    var _this5;
    _classCallCheck(this, FreeGiftsBanner);
    _this5 = _super4.call(this);
    _this5.freeGifts = _this5.querySelectorAll('[data-threshold]');
    _this5.productPrice = parseInt(_this5.dataset.productPrice);
    _this5.displayFreeGiftsBanner = false;
    if (_this5.productPrice != null) {
      _this5.freeGifts.forEach(function (gift) {
        var threshold = parseInt(gift.dataset.threshold) * Shopify.currency.rate;
        if (threshold != null && _this5.productPrice >= threshold) {
          gift.style.display = 'flex';
          _this5.displayFreeGiftsBanner = true;
        } else {
          gift.style.display = 'none';
        }
      });
    }
    if (_this5.displayFreeGiftsBanner) {
      _this5.style.display = 'block';
    }
    return _this5;
  }
  return _createClass(FreeGiftsBanner);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('free-gifts-banner')) {
  customElements.define('free-gifts-banner', FreeGiftsBanner);
}

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkhandee"] = self["webpackChunkhandee"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;